import { Map } from 'immutable';

import { parseMaterialsFromInput, tagsFromArray } from '../../tags';
import { getMaterialsError } from '../../validations/materials';
import { clearErrors } from '../../errors';
import { keepOld } from '../../iterable/keepOld';

import { MAX_NUMBER_OF_MATERIALS } from '../../../constants/validations';
import { OPERATIONS } from '../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../constants/attributes';
import { VALUE } from '../../../constants/product';
import { FORM } from '../../../constants/forms';

export default function materials({ actions, operation, product }) {
  const channel = product.get('channel');

  function validateAndApply(value) {
    return {
      actions,
      product: getMaterialsError({ channel, materials: value })
        ? product
        : clearErrors({
          errors: [ATTRIBUTE.MATERIALS],
          path: FORM.DETAILS,
          product: product.setIn([FORM.DETAILS, ATTRIBUTE.MATERIALS], Map({ value })),
        }),
    };
  }

  switch (operation.get('type')) {
    case OPERATIONS[channel].MATERIALS.ADD: {
      const productValue = product.getIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, VALUE]);

      if (productValue.size >= MAX_NUMBER_OF_MATERIALS[channel]) break;

      const operationValue = parseMaterialsFromInput({
        channel,
        materials: productValue,
        value: operation.get(VALUE),
      });

      return validateAndApply(productValue.mergeWith(keepOld, operationValue));
    }

    case OPERATIONS[channel].MATERIALS.CHANGE_TO: {
      const value = tagsFromArray(operation.get('value'));
      return validateAndApply(value);
    }

    case OPERATIONS[channel].MATERIALS.DELETE: {
      const operationValue = parseMaterialsFromInput({ channel, value: operation.get(VALUE) });
      const value = product.getIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, VALUE]).deleteAll(operationValue.keySeq());
      return validateAndApply(value);
    }

    default: {
      break;
    }
  }

  return { actions, product };
}

